import React from 'react'
import { DATA_TEST_ID } from 'shared-constants/build/testIds'
import { H4 } from 'components/Typography'
import { COLOR, FONT_WEIGHT } from 'Theme'

export const Title: React.FC<React.PWC> = ({ children }) => (
  <H4
    data-test-id={DATA_TEST_ID.SIDE_NAV_PAGE_TITLE}
    color={COLOR.GRAYSCALE_1}
    fontWeight={FONT_WEIGHT.MEDIUM}
    m={0}
  >
    {children}
  </H4>
)
